import { ApiProperty } from "@nestjs/swagger";

export class IndentAbstractRequest {
    fromDate: Date;
    toDate: Date;
    constructor(fromDate: Date, toDate: Date) {
        this.fromDate = fromDate;
        this.toDate = toDate;
    }
}